import React, {useEffect, useState} from 'react'
import {Button, message, Spin, Tabs,Form,Input,Select, Image, Modal} from 'antd';
import styled from 'styled-components'

import {MarkdownEditor} from '../../../components/MarkdownEditor';
import {useTranslation} from 'react-i18next';
import {bind2FA, editMfInfo, getMfInfo, twoFA, unbind2FA} from "../../../api/User";
import { CustomInput } from '../../../components/CustomForm';
import { Layout } from 'antd';
import {
    TwoFaConfiguredIcon,
    TwoFAIcon,
  } from '../../../icons';
import { useDispatch } from 'react-redux';
import { setTwoFA } from '../../../features/user/userSlice';

const { Header, Footer, Sider, Content } = Layout;

const Container = styled.div`
  padding: 20px;
`

const SubmitButton = styled(Button)`
  margin-top: 40px;
  height: 42px;
  background-color: #18EAC4;
  color: #0e0e0e;
  border: none;
`



export const TwoFA = () => {
    
    const [verifyCode, setVerifyCode] = useState('');
    const [pageLoading, setPageLoading] = useState(false);
    const [qrImage, setQrImage] = useState("data:image/png;base64,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");
    const [secretKey, setSecretKey] = useState(false);
    const [twoFAEnabled, setTwoFAEnabled] = useState(localStorage.getItem('twoFA')??"0");
    const dispatch = useDispatch();
    
    const [resetVisible, setResetVisible] = useState(false);

    const { t } = useTranslation();

    const getTwoFAInfo = async () => {
        setPageLoading(true);
        try {
            const { code, data } = await twoFA();
            if (code === '10000') {
                setQrImage(data.qrImage)
                setSecretKey(data.secretKey)
            }
        } catch (error) {
            setPageLoading(false);
        }
        setPageLoading(false);
    };

    useEffect(() => {
        if(twoFAEnabled==="0"){
            getTwoFAInfo();
        }
    }, [twoFAEnabled])

    const submit = async () => {
        const { code } = await bind2FA({
            secret_key: secretKey,
            secret: verifyCode,
        });
        if (code === '10000') {
            setTwoFAEnabled("1");
            dispatch(setTwoFA("1"));
        }
    }

    const reset2FA = async () => {
        const { code } = await unbind2FA();
        if (code === '10000') {
            setTwoFAEnabled("0");
            setResetVisible(false);
            dispatch(setTwoFA("0"));
        }
    }

    // JSX Components DeleteModal
    const ResetModal = ({ visible, handleOk, handleCancel }) => {
        return (
        <Modal open={visible} onOk={handleOk} onCancel={handleCancel}>
            Are you sure you want to reset 2-FA?
        </Modal>
        );
    };

    const handleReset = () => {
        setResetVisible(true);
      };

    // function confirm delete
    const handleResetOK = () => {
        reset2FA(() => {
            setResetVisible(false);
        });
    };

    // function cancel delete
    const handleResetCancel = () => {
        setResetVisible(false);
    };

    const onVerifyCodeChange = (e) => {
        setVerifyCode(e.target.value);
    }

    if(twoFAEnabled==="1"){
        return (
            <Spin spinning={pageLoading}>
                <Container>
                    <Layout>
                        <Layout style={{
                            "backgroundColor":"#0e0e0e",
                        }}>
                            <Sider width={50} height={50} style={{
                                "background":"none"
                            }}>
                                <TwoFaConfiguredIcon/>
                            </Sider>
                            <Content style={{
                                "backgroundImage":"none"
                            }}>
                                <div style={{
                                    "height": "50px",
                                    "lineHeight": "50px",
                                    "marginBottom":"13px"
                                }}>
                                    {t('user_center.2fa.configured')}
                                    </div>
                            </Content>
                        </Layout>
                    </Layout>
    
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={() => {
                    handleReset();
                  }}
                  style={{
                    backgroundColor: '#333333',
                    color: '#fff',
                    borderColor: '#18EAC4',
                    borderRadius: '4px',
                    marginLeft:'50px',
                    border:'none',
                    width:'81px'
                
                  }}
                >
                    Reset
                </Button>
                <ResetModal
                    visible={resetVisible}
                    handleCancel={handleResetCancel}
                    handleOk={handleResetOK}
                />
                </Container>
            </Spin>
        )
    }else{
        return (
            <Spin spinning={pageLoading}>
                <Container>
                    <Layout>
                        <Header style={{
                            "padding":0,
                            "color":"#fff"
                        }}>
                            <span>
                                {t('user_center.2fa.title')}
                            </span>
                        </Header>
                        <Layout style={{
                            "backgroundColor":"#0e0e0e",
                            display: "flex",
                            alignItems: 'center'
                        }}>
                            <Sider width={90} style={{
                                "background":"none",
                                "width":"90px",
                                "height":"90px",
                            }}>
                                <Image
                                    width={90}
                                    height={90}
                                    src={`${qrImage}`}
                                    placeholder={true}
                                />
                            </Sider>
                            <Content style={{
                                "marginLeft":"29px",
                                "backgroundImage":"none"
                            }}>
                                <div style={{
                                    "min-height": "13px",
                                    "fontSize": "12px",
                                    "color": "#4D555D",
                                    "marginBottom":"13px"
                                }}>{t('user_center.2fa.description')}</div>
                                <div>{secretKey}</div>
                                </Content>
                        </Layout>
                    </Layout>
                    <Form layout="vertical" style={{
                        "marginTop":"11px"
                    }}>
                        <Form.Item
                            label={t('user_center.2fa.VerifyTitle')}
                            name={'max_reward'}
                        >
                            <CustomInput
                                type="text"
                                value={verifyCode}
                                onChange={onVerifyCodeChange}
                                style={{ maxWidth: 400,textAlign: 'left' }}
                                className="personal-input"
                                placeholder={'XXXXXX'}
                            />
                        </Form.Item>
                    </Form>
    
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={submit}
                  style={{
                    backgroundColor: '#18EAC4',
                    color: '#000000',
                    borderColor: '#18EAC4',
                    borderRadius: '4px',
                  }}
                >
                        {t('addreport.submit')}
                </Button>
                </Container>
            </Spin>
        )
    }
    
}
